import { component } from 'picoapp';
import { getCart } from 'utils/cart';
import Drawer from 'utils/drawer';

export default component((node, ctx) => {
  const { editItem: id } = node.dataset;

  const attachOverlay = node.parentNode;
  const drawer = Drawer(node, attachOverlay);

  const currentVariant = Number(node.querySelector('input[name="id"]:checked').value);

  document.addEventListener('edit:toggle', (event) => {
    const { key } = event.detail;
    if (id === key) drawer.open();
  });

  const submit = async (event) => {
    event.preventDefault();

    ctx.emit('cart:updating');

    const formData = new FormData(node);
    const variant = formData.get('id');

    // If variant changed, remove current variant, and replace with new
    if (currentVariant !== Number(variant)) {
      // Remove variant
      await fetch(`${node.action}.js`, {
        method: node.method,
        headers: {
          'Content-type': 'application/json',
        },
        body: JSON.stringify({ id, quantity: 0 }),
      });

      // Add variant on new
      await fetch(`${window.theme.routes.cartAdd}.js`, {
        method: node.method,
        body: formData,
      });
    } else {
      await fetch(`${node.action}.js`, {
        method: node.method,
        body: formData,
      });
    }

    const cart = await getCart();
    drawer.close();

    ctx.emit('cart:updated', ({ cart }));
  };

  node.addEventListener('submit', submit);
});
